// Helper function to access deeply nested fields
const getNestedValue = (object, path) => {
  const fields = path.split('.'); // Split by dot to handle nested fields
  return fields.reduce((acc, field) => {
    if (acc && acc.hasOwnProperty(field)) {
      return acc[field];
    }
    return undefined; // If field doesn't exist, return undefined
  }, object);
};

const evaluateCondition = (condition, data) => {
  const value = getNestedValue(data, condition.field); // Access the nested field

  switch (condition.operator) {
    case 'isEquals':
      return value === condition.value;
    case 'isGreaterThan':
      return value > condition.value;
    case 'isNotEmpty':
      return value !== '' && value !== null && value !== undefined && value.length !== 0;
    case 'contains':
      if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
        // Special handling for objects (e.g., checking if a key exists in a nested object)
        return Object.keys(value).includes(condition.value);
      }
      return value && value.includes(condition.value);
    default:
      console.error('Unsupported operator:', condition.operator);
      console.error('Condition:', condition);
      console.error('Data:', data);
      return false;
  }
};

const fetchRules = async () => {
  try {
    const response = await fetch('rules.json');
    const jsonData = await response.json();
    console.log('Fetched rules:', jsonData.rules);
    return jsonData.rules;
  } catch (error) {
    console.error('Failed to fetch rules:', error);
    throw error;
  }
};

export const RulesEngine = {
  applyRules: async (data) => {
    console.log('Applying rules to data:', data);
    try {
      const rules = await fetchRules();
      return rules.filter(rule => evaluateCondition(rule.condition, data));
    } catch (error) {
      console.error('Error applying rules:', error);
      return []; // Return an empty array if something goes wrong
    }
  }
};
